<div *ngIf="isDemoUser" style="margin-bottom: 15px;">
  <div class="alert alert-warning">
      <p style="margin-bottom: 0;">Demo Limitations: Comorbidity for only 2 selections can be made from the "Other Diseases" category.</p>
  </div>
</div>

<div *ngIf="hasReachedDemoSelectionLimit() || hasReachedSelectionLimit()" style="margin-bottom: 15px;">
  <div class="alert alert-danger">
      <p style="margin-bottom: 0;">{{selectionLimitMessage()}}</p>
  </div>
</div>

<app-search-indications></app-search-indications>
<kendo-panelbar #searchPanelbar [keepItemContent]="true" width="100%" [expandMode]="expandMode">
  <kendo-panelbar-item *ngIf="!showSelectedFiltersPanel" [title]="'Filter Selections'">
    <ng-template kendoPanelBarContent>
        <app-filter-selections></app-filter-selections>
    </ng-template>
  </kendo-panelbar-item>
  <kendo-panelbar-item *ngIf="!showSelectedFiltersPanel" [title]="'Query History'">
    <ng-template kendoPanelBarContent>
        <app-previous-queries></app-previous-queries>
    </ng-template>
  </kendo-panelbar-item>
  <kendo-panelbar-item *ngIf="!showSelectedFiltersPanel" [title]="'Saved Queries'">
    <ng-template kendoPanelBarContent>
        <app-saved-filters></app-saved-filters>
    </ng-template>
  </kendo-panelbar-item>
  <kendo-panelbar-item *ngFor="let indicationGroup of allIndications" [title]="indicationGroup.displayName">
    <ng-template kendoPanelBarItemTitle>
      <span style="float: left; width: 90%">{{indicationGroup.displayName}}</span>
      <span *ngIf="getSelectedIndicationsInGroupCount(indicationGroup) > 0" style="float: right; width: 10%">{{getSelectedIndicationsInGroupCount(indicationGroup)}} 
        <!-- <kendo-svg-icon class="custom-icon-size" *ngIf="getUncheckedIcon(indicationGroup)"size="medium" [icon]="checkboxIcon"></kendo-svg-icon>
        <kendo-svg-icon class="custom-icon-size" *ngIf="getCheckedIcon(indicationGroup)" size="medium" [icon]="checkboxCheckedIcon"></kendo-svg-icon> -->
      </span>
    </ng-template>
    <ng-template kendoPanelBarContent>
      <div class="container-fluid">
        <div class="row" style="padding-bottom: 1em; padding-top: 1em">
          <div class="col-sm-12">
            <app-indication-group [indicationGroup]="indicationGroup"></app-indication-group>
          </div>
        </div>
      </div>
    </ng-template>
  </kendo-panelbar-item>
</kendo-panelbar>
<!-- <div class="ph-item">
  <div class="ph-col-12">
      <div class="ph-picture"></div>
      <div class="ph-row">
          <div class="ph-col-6 big"></div>
          <div class="ph-col-4 empty big"></div>
          <div class="ph-col-2 big"></div>
          <div class="ph-col-4"></div>
          <div class="ph-col-8 empty"></div>
          <div class="ph-col-6"></div>
          <div class="ph-col-6 empty"></div>
          <div class="ph-col-12"></div>
      </div>
  </div>
</div> -->

<div id="runQueryScrollToDiv"></div>